import React, { useState, useEffect, useRef } from 'react';
import firebase from '../../../Firebase/firebaseConnection';
import AppleSignin from 'react-apple-signin-auth';
import { Eye, EyeOff } from 'react-feather';
import axios from 'axios';
import { useSettingsManager } from '../../../Configuration/SettingsManager';

import logoNextStock from '../../../img/Next Stock Logo.png';
import ggoogleIcon from '../../../img/Ggoogle-icon.jpg';
import facebookIcon from '../../../img/facebook-icon.png';
import appleIcon from '../../../img/Apple-icon.png';
import './Signin.css';

import { useTranslation } from "react-i18next";

import AlertManager from "../../../Resources/AlertManager";
import NodeBackend from "../../../Resources/NodeBackend";

const backend = new NodeBackend();
const API_ENDPOINT = backend.getPath();


export default function Signin({ setPage }) {

    const { t, i18n } = useTranslation();

    const { handleSettingsPress } = useSettingsManager();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [loading, setLoading] = useState(true);

    const [authModalVisible, setAuthModalVisible] = useState(false);
    const [authModalMode, setAuthModalMode] = useState(null);
    const [checkingEmail, setCheckingEmail] = useState(false);

    // Detect url
    const isCloudflareApp =
        window.location.host === 'app.nextstock.ca' ||
        window.location.host === 'localhost:3000';

    const appleClickRef = useRef(null);
    const [showAppleModal, setShowAppleModal] = useState(false);

    const passwordRef = React.useRef(null);

    useEffect(() => {
        if (authModalVisible && passwordRef.current) {
            passwordRef.current.focus();
        }
    }, [authModalVisible]);


    // --------------------------------------------------
    // Helpers
    // --------------------------------------------------
    function setLoginExpiration(days = 30) {
        const expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
        localStorage.setItem('loginExpiration', String(expiresAt));
    }

    function isLoginExpired() {
        const expiration = localStorage.getItem('loginExpiration');
        if (!expiration) return true;
        const expiresAt = Number(expiration);
        return Number.isNaN(expiresAt) || Date.now() > expiresAt;
    }

    // Username based on email
    function getNameFromEmail(emailStr) {
        if (!emailStr) return '';
        const [beforeAt] = emailStr.split('@');
        return beforeAt || emailStr;
    }

    async function handleEmailContinue() {
        if (!email || !email.includes('@')) {
            AlertManager.show({
                type: "warning", // "error", "warning", or "message"
                title: "Missing email address",
                message: "Please enter a valid email address.",
                buttonText: "Got it!"
            });
            return;
        }

        try {
            setCheckingEmail(true);

            // Email exists?
            const methods = await firebase.auth().fetchSignInMethodsForEmail(email);

            if (methods && methods.length > 0) {
                setAuthModalMode('signin');
            } else {
                setAuthModalMode('signup');
            }

            setPassword('');
            setPassword2('');
            setAuthModalVisible(true);
        } catch (error) {
            console.error('Error checking email:', error);
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Action Failed",
                message: "Sorry, we could not verify your email. Please try again.",
                buttonText: "Got it!"
            });
        } finally {
            setCheckingEmail(false);
        }
    }

    // Login a partir do modal (modo "signin")
    async function handleEmailPasswordLogin() {
        if (!password) {
            AlertManager.show({
                type: "warning", // "error", "warning", or "message"
                title: "Action Failed",
                message: "Please enter your password.",
                buttonText: "Got it!"
            });
            return;
        }

        await login();
        // If all correct, send to saveUserOnLocalStorage
        setAuthModalVisible(false);
    }

    // Cadastro a partir do modal (modo "signup")
    async function handleEmailSignupFromModal() {
        if (
            password !== password2 ||
            !email ||
            !email.includes('@') ||
            password.length < 6
        ) {
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Missing email address",
                message: 'Invalid credentials: \n\n' +
                    '- Check your password and confirmation.\n' +
                    '- Use a valid email address.\n' +
                    '- Password must be at least 6 characters.',
                buttonText: "Got it!"
            });
            return;
        }

        const name = getNameFromEmail(email);

        try {
            // 1) Cria usuário no Firebase Auth
            const cred = await firebase
                .auth()
                .createUserWithEmailAndPassword(email, password);

            const uid = cred.user.uid;

            // 2) Backend: cria registro em Users, gera código de validação e envia e-mail
            const response = await axios.post(
                `${API_ENDPOINT}send-signup-confirmation-email`,
                {
                    uid,
                    email,
                    name,
                }
            );

            if (!response.data || response.data.status !== 'success') {
                AlertManager.show({
                    type: "error", // "error", "warning", or "message"
                    title: "Activation email failed",
                    message: "Sorry. Something went wrong. Please contact us at developer@nextstock.ca",
                    buttonText: "Got it!"
                });
                return;
            }

            // 3) Guarda info básica no localStorage
            localStorage.setItem('userUid', uid);
            localStorage.setItem('userEmail', email);

            // 4) Limpa campos e vai para confirmação
            setPassword('');
            setPassword2('');
            setAuthModalVisible(false);
            setPage('AccountConfirmation');
        } catch (error) {
            switch (error.code) {
                case 'auth/email-already-in-use':
                    AlertManager.show({
                        type: "error", // "error", "warning", or "message"
                        title: "Action failed",
                        message: "This email is already registered. Please use a different email or sign in.",
                        buttonText: "Got it!"
                    });
                    break;
                case 'auth/invalid-email':
                    AlertManager.show({
                        type: "error", // "error", "warning", or "message"
                        title: "Invalid email format",
                        message: "Please enter a valid email.",
                        buttonText: "Got it!"
                    });
                    break;
                case 'auth/weak-password':
                    AlertManager.show({
                        type: "error", // "error", "warning", or "message"
                        title: "Password is too weak",
                        message: "Please use at least 6 characters.",
                        buttonText: "Got it!"
                    });
                    break;
                default:
                    AlertManager.show({
                        type: "error", // "error", "warning", or "message"
                        title: "Sorry! Something went wrong",
                        message: (error.message || error),
                        buttonText: "Close"
                    });
            }
            console.error("Signup error (modal):", error);
        }
    }


    // --------------------------------------------------
    // Initial Auto-login + Redirect Check
    // --------------------------------------------------
    useEffect(() => {
        async function checkRedirectResult() {
            try {
                const result = await firebase.auth().getRedirectResult();
                if (result.user) {
                    await handleFacebookResult(result);
                }
            } catch (error) {
                console.error('Redirect login error:', error.message);
            }
        }

        const urlParams = new URLSearchParams(window.location.search);
        const forcedPage = urlParams.get('page');

        // If user forced privacy policy page
        if (forcedPage === 'ns-privacy-policy') {
            setPage('PrivacyPolicy');
            return;
        }
        // If user forced privacy policy page
        if (forcedPage === 'next-stock-ai-public-chat') {
            setPage('next-stock-ai-public-chat');
            return;
        }

        checkRedirectResult();
        loadStorage();
    }, [isCloudflareApp]);

    // --------------------------------------------------
    // RESTORE SESSION (Backend)
    // --------------------------------------------------
    async function loadStorage() {
        const userUid = localStorage.getItem('userUid');

        if (!userUid || isLoginExpired()) {
            localStorage.clear();
            setLoading(false);

            // 🔍 If on GitHub and coming from Cloudflare with Apple provider,
            // show a modal asking user to continue with Apple.
            const urlParams = new URLSearchParams(window.location.search);
            const loginProvider = urlParams.get('login-provider');
            const isGitHub = window.location.host.includes('github.io');

            if (loginProvider === 'apple' && isGitHub && !isCloudflareApp) {
                setShowAppleModal(true);
            }

            return;
        }

        try {
            const res = await fetch(
                `${API_ENDPOINT}load-data-restore-session`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ uid: userUid }),
            }
            );

            const data = await res.json();

            console.log("Plan just changed: " + data.planStatusChanged);

            if (!res.ok || data.status !== 'succeed') {
                localStorage.clear();
                setLoading(false);
                return;
            }

            const userDb = data.user;

            localStorage.setItem('userUid', data.uid);
            localStorage.setItem('userEmail', userDb.email);
            localStorage.setItem('userName', userDb.name);
            localStorage.setItem('userStatus', userDb.status);
            localStorage.setItem('userTrial', userDb?.plan?.trial ?? false);

            setLoginExpiration(30);

            if (userDb.accountValidationRequired && userDb.accountValidationCode) {
                setPage('AccountConfirmation');
                return;
            }

            const baseUrl = window.location.origin + window.location.pathname.split("?")[0];
            const params = new URLSearchParams(window.location.search);
            const current = params.get('page');

            if (data.planStatusChanged) {
                AlertManager.show({
                    type: "warning",
                    title: "Your Premium Plan Has Ended",
                    message: "Your premium features are now disabled. Upgrade again to continue enjoying full access.",
                    buttonText: "Upgrade Now",
                    onClose: handleSettingsPress
                });
            }

            if (current === 'Logout') {
                localStorage.clear();
                window.location.href = `${baseUrl}?page=Signin`;
                return;
            }

            const validPages = [
                'Signin', 'Home', 'ai-chat', 'next-stock-ai-public-chat', 'Searchp', 'Top10',
                'Youtube', 'Settings', 'PrivacyPolicy', 'AccountConfirmation', 'Portfolio'
            ];

            const deletionRequestToken = new URLSearchParams(window.location.search).get('deletion_request');
            let nextPage = validPages.includes(current) ? current : 'Home';

            // If logged in AND we are on Signin page, redirect to Home
            if (current === 'Signin') {
                nextPage = 'Home';
            }

            window.scrollTo(0, 0);
            setPage(nextPage);

            // Sync
            if (current !== nextPage) {
                const newUrl = `${baseUrl}?page=${nextPage}${deletionRequestToken ? `&deletion_request=${encodeURIComponent(deletionRequestToken)}` : ""}`;
                window.history.replaceState(null, '', newUrl);
            }

        } catch (error) {
            console.error('Error restoring session:', error);
            localStorage.clear();
        } finally {
            setLoading(false);
        }
    }

    // --------------------------------------------------
    // Save Login (Backend)
    // --------------------------------------------------
    async function saveUserOnLocalStorage(uid, extraAuthInfo = {}) {
        try {
            const res = await fetch(
                `${API_ENDPOINT}post-login-user-handler`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    uid,
                    email: extraAuthInfo.email,
                    displayName: extraAuthInfo.displayName,
                }),
            }
            );

            const data = await res.json();

            if (!res.ok || data.status !== 'succeed') {
                throw new Error(data.error || 'Post-login failed');
            }

            const userDb = data.user;

            localStorage.setItem('userUid', data.uid);
            localStorage.setItem('userEmail', userDb.email);
            localStorage.setItem('userName', userDb.name);
            localStorage.setItem('userStatus', userDb.status);
            localStorage.setItem('userTrial', userDb?.plan?.trial ?? false);

            setLoginExpiration(30);

            if (userDb.accountValidationRequired && userDb.accountValidationCode) {
                setPage('AccountConfirmation');
                return;
            }

            const params = new URLSearchParams(window.location.search);
            const current = params.get('page');

            const validPages = [
                'Signin', 'Home', 'ai-chat', 'next-stock-ai-public-chat', 'Searchp', 'Top10',
                'Youtube', 'Settings', 'PrivacyPolicy', 'AccountConfirmation', 'Portfolio'
            ];

            let nextPage = validPages.includes(current) ? current : 'Home';

            if (data.planStatusChanged) {
                AlertManager.show({
                    type: "warning",
                    title: "Your Premium Plan Has Ended",
                    message: "Your premium features are now disabled. Upgrade again to continue enjoying full access.",
                    buttonText: "Upgrade Now",
                    onClose: handleSettingsPress
                });
            }

            const deletionRequestToken = new URLSearchParams(window.location.search).get('deletion_request');
            if (deletionRequestToken) {
                nextPage = 'Settings';
            } else if (!current || current === 'Signin') {
                nextPage = 'Home';
            }

            // Logout case
            if (nextPage === 'Logout') {
                localStorage.clear();
                setPage('Signin');
                // window.open('https://next-stock.github.io/app', '_self');
                window.open('https://app.nextstock.ca', '_self');
                return;
            }

            setEmail('');
            setPassword('');
            window.scrollTo(0, 0);
            setPage(nextPage);

            const baseUrl = window.location.origin + window.location.pathname.split("?")[0];
            if (current !== nextPage) {
                const newUrl = `${baseUrl}?page=${nextPage}${deletionRequestToken ? `&deletion_request=${encodeURIComponent(deletionRequestToken)}` : ""}`;
                window.history.replaceState(null, '', newUrl);
            }

        } catch (error) {
            console.error('saveUserOnLocalStorage error:', error);
            localStorage.clear();
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Sorry! Something went wrong",
                message: "Could not load your account. Please try again.",
                buttonText: "Close"
            });
        }
    }

    // --------------------------------------------------
    // Email Login
    // --------------------------------------------------
    async function login() {
        try {
            const result = await firebase.auth().signInWithEmailAndPassword(email, password);
            const user = result.user;

            await saveUserOnLocalStorage(user.uid, {
                email: user.email,
                displayName: user.displayName,
            });

        } catch (error) {
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Invalid email or password",
                message: error.message || String(error) || "",
                buttonText: "Close"
            });
            setPassword('');
        }
    }

    // --------------------------------------------------
    // Google Login
    // --------------------------------------------------
    async function signInWithGoogle() {
        const provider = new firebase.auth.GoogleAuthProvider();

        try {
            const result = await firebase.auth().signInWithPopup(provider);
            const user = result.user;

            await saveUserOnLocalStorage(user.uid, {
                email: user.email,
                displayName: user.displayName,
            });

        } catch (error) {
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Google sign-in failed",
                message: error.message || String(error) || "",
                buttonText: "Close"
            });
        }
    }

    // --------------------------------------------------
    // Facebook Login
    // --------------------------------------------------
    async function signInWithFacebook() {
        const provider = new firebase.auth.FacebookAuthProvider();

        try {
            const result = await firebase.auth().signInWithPopup(provider);
            await handleFacebookResult(result);

        } catch (error) {
            if (error.code === 'auth/popup-blocked' || error.message.includes('popup')) {
                await firebase.auth().signInWithRedirect(provider);
            } else {
                AlertManager.show({
                    type: "error", // "error", "warning", or "message"
                    title: "Facebook sign-in failed",
                    message: error.message || String(error) || "",
                    buttonText: "Close"
                });
            }
        }
    }

    // async function handleFacebookResult(result) {
    //     try {
    //         const user = result.user;

    //         await saveUserOnLocalStorage(user.uid, {
    //             email: user.email,
    //             displayName: user.displayName,
    //         });

    //     } catch (error) {
    //         AlertManager.show({
    //             type: "error", // "error", "warning", or "message"
    //             title: "Sorry! Something went wrong",
    //             message: error.message || String(error) || "",
    //             buttonText: "Close"
    //         });
    //     }
    // }

    async function handleFacebookResult(result) {
        try {
            const user = result.user;

            await saveUserOnLocalStorage(user.uid, {
                email: user.email,
                displayName: user.displayName,
            });

        } catch (error) {

            if (error.code === "auth/account-exists-with-different-credential") {
                const email = error.customData?.email;
                const pendingCred = error.credential;

                const methods = await firebase.auth().fetchSignInMethodsForEmail(email);
                // 1️⃣ Google first (auto attempt — most common case)
                if (methods.includes("google.com")) {
                    try {
                        const googleProvider = new firebase.auth.GoogleAuthProvider();
                        const existingUser = await firebase.auth().signInWithPopup(googleProvider);
                        await existingUser.user.linkWithCredential(pendingCred);

                        await saveUserOnLocalStorage(existingUser.user.uid, {
                            email: existingUser.user.email,
                            displayName: existingUser.user.displayName,
                        });
                        return;
                    } catch (e) {
                        console.warn("Google auto-link failed, falling back...", e);
                    }
                }

                // 2️⃣ Apple fallback (must be user-initiated)
                if (methods.includes("apple.com")) {
                    AlertManager.show({
                        type: "warning",
                        title: "Continue with Apple",
                        message: "This email is linked to an Apple account. Please continue with Apple to finish signing in.",
                        buttonText: "Continue",
                        onClose: () => {
                            if (appleClickRef?.current) {
                                appleClickRef.current();
                            }
                        }
                    });
                    return;
                }

                // 3️⃣ Password LAST (annoying but safe)
                if (methods.includes("password")) {
                    AlertManager.show({
                        type: "warning",
                        title: "Sign in required",
                        message: "Please sign in with your email and password to link Facebook.",
                        buttonText: "OK"
                    });
                    return;
                }

            }

            AlertManager.show({
                type: "error",
                title: "Sorry! Something went wrong",
                message: error.message || String(error) || "",
                buttonText: "Close"
            });
            return;
        }
    }


    // --------------------------------------------------
    // Apple Login
    // --------------------------------------------------
    const handleAppleSuccess = async (response) => {
        try {
            const idToken = response.authorization?.id_token;
            if (!idToken) throw new Error('Missing id_token');

            const res = await fetch(
                `${API_ENDPOINT}handle-apple-auth-login`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ idToken }),
            }
            );

            const data = await res.json();
            if (!res.ok || data.status !== 'succeed') {
                throw new Error(data.error || 'Apple auth failed');
            }

            // 1️⃣ Login Apple user into Firebase Auth using Custom Token
            if (data.firebaseCustomToken) {
                await firebase.auth().signInWithCustomToken(data.firebaseCustomToken);
            }

            // 2️⃣ Continue with your normal session logic
            await saveUserOnLocalStorage(data.uid, {
                email: data.email,
                displayName: data.name || (data.email ? data.email.split('@')[0] : ''),
            });

        } catch (error) {
            AlertManager.show({
                type: "error", // "error", "warning", or "message"
                title: "Apple sign-in failed",
                message: error.message || String(error) || "",
                buttonText: "Close"
            });
        }
    };

    const handleAppleError = () => {
        AlertManager.show({
            type: "error", // "error", "warning", or "message"
            title: "Action failed",
            message: "Apple sign-in cancelled or failed.",
            buttonText: "Close"
        });
    };

    // --------------------------------------------------
    // Reset Password
    // --------------------------------------------------
    async function ResetPasswordEmail() {
        if (!email.includes('@')) {
            AlertManager.show({
                type: "warning", // "error", "warning", or "message"
                title: "Action failed",
                message: "Invalid email address.",
                buttonText: "Close"
            });
            return;
        }

        try {
            await firebase.auth().sendPasswordResetEmail(email);
            AlertManager.show({
                type: "message", // "error", "warning", or "message"
                title: "Email sent",
                message: `We've sent a secure password reset link to \n\n${email}\n\n... ` +
                    `If it doesn't appear in your inbox shortly, please check your Spam, Junk, or Promotions folder.`,
                buttonText: "Close"
            });
        } catch (error) {
            AlertManager.show({
                type: "message", // "error", "warning", or "message"
                title: "Action failed",
                message: `Error sending reset email: ${error}`,
                buttonText: "Close"
            });
        }
    }

    // --------------------------------------------------
    // RENDER
    // --------------------------------------------------
    return (
        <div className="container">
            {loading ? (
                <div className="loading">
                    <div className="spinner"></div>
                </div>
            ) : (
                <div className="content">

                    <div className="lang-switch">
                        <button
                            type="button"
                            className={i18n.language === "en" ? "active" : ""}
                            onClick={() => i18n.changeLanguage("en")}
                        >
                            EN
                        </button>

                        <button
                            type="button"
                            className={i18n.language === "fr" ? "active" : ""}
                            onClick={() => i18n.changeLanguage("fr")}
                        >
                            FR
                        </button>
                    </div>

                    <div className="overlay">

                        {/* Apple modal */}
                        {showAppleModal && (
                            <div className="apple-modal-backdrop">
                                <div className="apple-modal-card">

                                    <img
                                        src={appleIcon}
                                        alt="Apple"
                                        className="apple-modal-logo"
                                    />

                                    <h2 className="apple-modal-title">
                                        {t("signin.appleTitle")}
                                    </h2>

                                    <p className="apple-modal-text">
                                        {t("signin.appleText")}
                                    </p>

                                    <div className="apple-modal-actions">
                                        <button
                                            type="button"
                                            className="apple-modal-btn-primary"
                                            onClick={() => {
                                                setShowAppleModal(false);

                                                if (appleClickRef.current) {
                                                    appleClickRef.current();
                                                }
                                            }}
                                        >
                                            {t("signin.continue")} →
                                        </button>

                                        <button
                                            type="button"
                                            className="apple-modal-btn-secondary"
                                            onClick={() => setShowAppleModal(false)}
                                        >
                                            {t("signin.cancel")}
                                        </button>
                                    </div>

                                </div>
                            </div>
                        )}

                        {/* Email modal */}
                        {authModalVisible && (
                            <div className="email-modal-backdrop">
                                <div className="email-modal-card">

                                    <button
                                        type="button"
                                        className="email-modal-close"
                                        aria-label="Close"
                                        onClick={() => setAuthModalVisible(false)}
                                    >
                                        ×
                                    </button>

                                    <div className="email-modal-header">

                                        <span className="email-modal-chip">
                                            {authModalMode === "signin"
                                                ? t("signin.signin")
                                                : t("signin.signup")}
                                        </span>

                                        <h2 className="email-modal-title">
                                            {authModalMode === "signin"
                                                ? t("signin.welcomeBack")
                                                : t("signin.createAccount")}
                                        </h2>

                                        <p className="email-modal-subtitle">
                                            {email}
                                        </p>

                                    </div>

                                    {/* Sign-in */}
                                    {authModalMode === "signin" && (
                                        <div className="email-modal-body">

                                            <div className="title-section">
                                                <label>
                                                    {t("signin.password")}
                                                </label>
                                            </div>

                                            <div className="password-container">
                                                <input
                                                    ref={passwordRef}
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    value={password}
                                                    onChange={(e) =>
                                                        setPassword(e.target.value)
                                                    }
                                                    onKeyDown={(e) =>
                                                        e.key === "Enter" &&
                                                        handleEmailPasswordLogin()
                                                    }
                                                />

                                                <button
                                                    className="toggle-password"
                                                    type="button"
                                                    aria-label={
                                                        showPassword
                                                            ? "Hide password"
                                                            : "Show password"
                                                    }
                                                    onClick={() =>
                                                        setShowPassword(
                                                            !showPassword
                                                        )
                                                    }
                                                >
                                                    {showPassword
                                                        ? <EyeOff size={19} />
                                                        : <Eye size={19} />}
                                                </button>
                                            </div>

                                            <button
                                                className="email-modal-primary-btn"
                                                onClick={
                                                    handleEmailPasswordLogin
                                                }
                                            >
                                                {t("signin.signin")}
                                            </button>

                                            <p className="forgot-text modal-forgot">
                                                {t("signin.forgotPassword")}

                                                <span
                                                    onClick={ResetPasswordEmail}
                                                    className="bottom-texts"
                                                >
                                                    {t("signin.reset")}
                                                </span>
                                            </p>

                                        </div>
                                    )}

                                    {/* Sign-up */}
                                    {authModalMode === "signup" && (
                                        <div className="email-modal-body">

                                            <p className="email-modal-info">
                                                {t("signin.autoUsername")}
                                            </p>

                                            <div className="title-section">
                                                <label>
                                                    {t("signin.password")}
                                                </label>
                                            </div>

                                            <div className="password-container">
                                                <input
                                                    ref={passwordRef}
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    value={password}
                                                    onChange={(e) =>
                                                        setPassword(e.target.value)
                                                    }
                                                />

                                                <button
                                                    className="toggle-password"
                                                    type="button"
                                                    aria-label={
                                                        showPassword
                                                            ? "Hide password"
                                                            : "Show password"
                                                    }
                                                    onClick={() =>
                                                        setShowPassword(
                                                            !showPassword
                                                        )
                                                    }
                                                >
                                                    {showPassword
                                                        ? <EyeOff size={19} />
                                                        : <Eye size={19} />}
                                                </button>
                                            </div>

                                            <div className="title-section">
                                                <label>
                                                    {t(
                                                        "signin.confirmPassword"
                                                    )}
                                                </label>
                                            </div>

                                            <div className="password-container">
                                                <input
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    value={password2}
                                                    onChange={(e) =>
                                                        setPassword2(
                                                            e.target.value
                                                        )
                                                    }
                                                />

                                                <button
                                                    className="toggle-password"
                                                    type="button"
                                                    aria-label={
                                                        showPassword
                                                            ? "Hide password"
                                                            : "Show password"
                                                    }
                                                    onClick={() =>
                                                        setShowPassword(
                                                            !showPassword
                                                        )
                                                    }
                                                >
                                                    {showPassword
                                                        ? <EyeOff size={19} />
                                                        : <Eye size={19} />}
                                                </button>
                                            </div>

                                            <button
                                                className="email-modal-primary-btn"
                                                onClick={
                                                    handleEmailSignupFromModal
                                                }
                                            >
                                                {t("signin.signup")}
                                            </button>

                                        </div>
                                    )}

                                </div>
                            </div>
                        )}

                        {/* Login box */}
                        <div
                            className={`login-box ${showAppleModal || authModalVisible
                                ? "login-box-blurred"
                                : ""
                                }`}
                        >
                            <img
                                src={logoNextStock}
                                alt="Next Stock"
                                className="logo"
                            />

                            <section className="welcome-panel">
                                <h1 className="welcome-title">
                                    {t("signin.welcomeTitle")}
                                </h1>

                                <p
                                    className="welcome-text"
                                    dangerouslySetInnerHTML={{
                                        __html: t("signin.welcomeTrialText")
                                    }}
                                />
                            </section>

                            <div className="social-buttons">

                                {/* Apple */}
                                <AppleSignin
                                    authOptions={{
                                        clientId: "ca.nextstock.app",
                                        scope: "name email",
                                        redirectURI:
                                            "https://app.nextstock.ca/apple-callback/",
                                        state:
                                            "nextstock_" +
                                            Math.random()
                                                .toString(36)
                                                .substring(2),
                                        nonce: Math.random()
                                            .toString(36)
                                            .substring(2),
                                        usePopup: true
                                    }}
                                    onSuccess={handleAppleSuccess}
                                    onError={handleAppleError}
                                    render={(props) => {
                                        appleClickRef.current = props.onClick;

                                        const handleAppleButtonClick = () => {
                                            props.onClick();
                                        };

                                        return (
                                            <button
                                                type="button"
                                                className="apple-btn"
                                                onClick={
                                                    handleAppleButtonClick
                                                }
                                            >
                                                <img
                                                    src={appleIcon}
                                                    className="apple-logo"
                                                    alt="Apple"
                                                />

                                                <div>
                                                    {t("signin.continueWith")}{" "}
                                                    <strong>Apple</strong>
                                                </div>
                                            </button>
                                        );
                                    }}
                                />

                                {/* Google */}
                                <button
                                    type="button"
                                    className="google-btn"
                                    onClick={signInWithGoogle}
                                >
                                    <img
                                        src={ggoogleIcon}
                                        className="google-logo"
                                        alt="Google"
                                    />

                                    <div>
                                        {t("signin.continueWith")}{" "}
                                        <strong>Google</strong>
                                    </div>
                                </button>

                                {/* Facebook */}
                                <button
                                    type="button"
                                    className="facebook-btn"
                                    onClick={signInWithFacebook}
                                >
                                    <img
                                        src={facebookIcon}
                                        className="facebook-logo"
                                        alt="Facebook"
                                    />

                                    <div>
                                        {t("signin.continueWith")}{" "}
                                        <strong>Facebook</strong>
                                    </div>
                                </button>

                            </div>

                            <div className="separator">
                                <span>or use email</span>
                            </div>

                            {/* Email-only section */}
                            <div className="title-section">
                                <label>
                                    {t("signin.emailAddress")}
                                </label>
                            </div>

                            <input
                                type="email"
                                value={email}
                                autoComplete="email"
                                onChange={(e) =>
                                    setEmail(e.target.value)
                                }
                                onKeyDown={(e) =>
                                    e.key === "Enter" &&
                                    handleEmailContinue()
                                }
                            />

                            <button
                                type="button"
                                className="login-btn"
                                onClick={handleEmailContinue}
                                disabled={checkingEmail}
                            >
                                {checkingEmail
                                    ? t("signin.checking")
                                    : `${t("signin.continue")} →`}
                            </button>

                            <div className="footer-divider"></div>

                            <p className="footer-text">
                                {t("signin.developedBy")}{" "}
                                <strong>OTANER TECH INC.</strong>
                            </p>

                        </div>
                    </div>
                </div>
            )}
        </div>
    );

}
